/**
 * Statusse der Änderungen an Kundendaten
 *  */ 
export enum iomBookingStateColor {
    applying = "red",
    confirmed = "#0B0B61",
    cancelling = "red",
    noState = "#ccc"
}